/* eslint-disable import/prefer-default-export */
import Shepherd from 'shepherd.js';

const USER_OPT_OUT = 'onboarding_optout';
const USER_FINISHED = 'onboarding_finished';

function getTourKey(tourName, flag) {
  return `${tourName}_${flag}`;
}

function tourFactory(tourName) {
  const tour = new Shepherd.Tour({
    tourName,
    useModalOverlay: true,
    defaultStepOptions: {
      classes: 'shepherd-theme-custom',
      scrollTo: true,
      highlightClass: 'highlight',
    },
  });

  tour.on('cancel', () => {
    localStorage.setItem(getTourKey(tour.options.tourName, USER_OPT_OUT), true);
  });

  tour.on('complete', () => {
    localStorage.setItem(getTourKey(tour.options.tourName, USER_FINISHED), true);
  });

  return tour;
}

function getTourStepButtons(tour, hideBack = false, hideNext = false) {
  const buttons = [];

  buttons.push({
    text: 'Encerrar guia',
    action: hideNext ? tour.complete : tour.cancel,
  });

  if (!hideBack) {
    buttons.push({
      text: 'Voltar',
      classes: 'prevTour',
      action: tour.back,
    });
  }

  if (!hideNext) {
    buttons.push({
      text: 'Próximo',
      classes: 'nextTour',
      action: tour.next,
    });
  }

  return buttons;
}

function checkMustShowTour(tourName) {
  const optout = getTourKey(tourName, USER_OPT_OUT);
  const finished = getTourKey(tourName, USER_FINISHED);

  return window.localStorage.getItem(optout) !== 'true'
          && window.localStorage.getItem(finished) !== 'true';
}

export {
  tourFactory,
  getTourStepButtons,
  checkMustShowTour,
  getTourKey,
  USER_OPT_OUT,
  USER_FINISHED,
};
